import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyDocuments } from '@/features/participant/documents'

export const Route = createFileRoute(
  '/_authenticated/_organization/documents/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact', 'supported_employee']),
  component: MyDocuments,
})
